import { IScheduleJob } from './schedule.job.model';
import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ScheduleService {
  private todo = {};

  public add(poll: IScheduleJob, update: boolean = false): string {

    if (poll.id.length < 2) { console.error('unable to subscribe: id has to be longer [' + poll.id + ']'); }

    if (this.alreadySubscribed(poll.id) && !update) {
      console.info('Already subscribed and update is disabled');
    } else {
      const timeout = moment.duration(poll.udpateInterval, 'seconds').asMilliseconds();
      const timer = setInterval(poll.callback, timeout);
      this.todo[poll.id] = timer;
    }

    return poll.id;
  }
  public remove(id: string): void {
    if (this.alreadySubscribed(id)) {
      clearInterval(this.todo[id]);
      delete this.todo[id];
    }
  }

  private alreadySubscribed(id: string): boolean {
    return _.has(this.todo, id);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/schedule.service/schedule.service.ts